module.exports = __webpack_public_path__ + "fonts/noto-sans-kr-57-700-normal.270cf5c.woff2";